import { getAuthInfo } from '@/awsCodes/awsUtils';
import { getAllPayload } from '@/utils/jwt';

let id = '';
let email = '';
/**
 *
 */
const getOrganizationId = () => id;

/**
 * サーバーからユーザーのemail情報を取ってくる
 */
const getEmail = async () => {
  try {
    const authInfo = await getAuthInfo();
    if (!authInfo) {
      return 'test@test.com';
    }
    const payload: any = getAllPayload(authInfo.idToken);
    return payload['email'];
  } catch (e) {
    return 'test@test.com';
  }
};

/**
 *
 */
const prepareOrganizationId = async () => {
  try {
    const authInfo = await getAuthInfo();
    if (!authInfo) {
      id = 'test';
      email = '';
    } else {
      const payload: any = getAllPayload(authInfo.idToken);
      id = payload['custom:organizationId'];
      email = payload.email;
    }
  } catch (e) {
    id = 'test';
    email = '';
  }
};

export { prepareOrganizationId, getOrganizationId, getEmail };
